__turbopack_context__.v({
  "actionButtonsWrapper": "_2auDEq_actionButtonsWrapper",
  "cell": "_2auDEq_cell",
  "column": "_2auDEq_column",
  "editLabelLayout": "_2auDEq_editLabelLayout",
  "orderActions": "_2auDEq_orderActions",
  "orderTitle": "_2auDEq_orderTitle",
  "statusWrapper": "_2auDEq_statusWrapper",
});
